import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languagedetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import packageJson from '../../../package.json';

export const supportedLngs = ['en', 'es', 'fr', 'pt', 'ct', 'eu'];
export const fallbackLng = 'en';

// Namespaces that only exist in Spanish (the language of their users). Every language loads the
// Spanish file, so there is a single version to maintain and no other language falls back to English.
const SPANISH_ONLY_NAMESPACES = ['dashboard\\SyncMonitorView'];

const buildVersion = process.env.REACT_APP_BUILD_TIME || packageJson.version;

i18n
  .use(Backend)
  .use(languagedetector)
  .use(initReactI18next)
  .init({
    react: { useSuspense: true },
    debug: false,
    initImmediate: false,
    supportedLngs,
    fallbackLng,
    load: 'languageOnly',
    preload: supportedLngs,
    backend: {
      loadPath: (lngs, namespaces) =>
        SPANISH_ONLY_NAMESPACES.includes(namespaces[0])
          ? `/locales/es/${namespaces[0]}.json`
          : `/locales/${lngs[0]}/${namespaces[0]}.json`,
      requestOptions: {
        cache: 'no-cache',
      },
      queryStringParams: {
        v: buildVersion,
      },
    },
    ns: [
      'auth\\LoginView',
      'app\\MenuSidebar',
      'privacy\\Privacy',
      'legal\\Legal',
      'cookies\\Cookies',
      'dashboard\\ResumeCards',
      'dashboard\\ResultsStatsView',
      'dashboard\\ChartUsage',
      'dashboard\\ChartResults',
      'dashboard\\ChartCognitiveStyle',
      'dashboard\\ChartInformationProcessing',
      'dashboard\\ChartMetaCognitive',
      'dashboard\\ChartNeuroDevelopment',
      'dashboard\\Publications',
      'dashboard\\AnalysisStatsView',
      'dashboard\\UserProfileView',
      'dashboard\\CenterCard',
      'dashboard\\CentersView',
      'dashboard\\DateFilters',
    ],
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});

i18n.on('initialized', () => {
  if (!supportedLngs.includes(i18n.language)) {
    const primaryLang = i18n.language.split('-')[0];

    i18n.changeLanguage(
      supportedLngs.includes(primaryLang) ? primaryLang : fallbackLng,
    );
  }
});

export default i18n;
